import { MarketplaceUser } from 'APIs/marketplace.users/marketplace.users.types';
import { ReactElement, useCallback } from 'react';

import UserDataTable from './UserDataTable';
import UserModal from './UserModal';
import { AddNewUser, TableHeader } from './styles';
import { UserFormProps, toUserFormProps } from './types';

type Props = {
  actionUsers: Array<string>;
  users: Array<MarketplaceUser>;
  fetchingError: string;
  marketplaceUser: MarketplaceUser | null;
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  isModalLoading: boolean;
  isLoading: boolean;
  modalErrorMsg: string;
  setModalErrorMsg: (modalerrorMsg: string) => void;
  setMarketplaceUser: (marketplaceUser: MarketplaceUser | null) => void;
  resendEmail: (userId: string) => void;
  saveMarketplaceUserHandler: (formData: UserFormProps) => void;
};

const UserList = ({
  actionUsers,
  users,
  fetchingError,
  marketplaceUser,
  showModal,
  setShowModal,
  isModalLoading,
  isLoading,
  modalErrorMsg,
  setModalErrorMsg,
  setMarketplaceUser,
  resendEmail,
  saveMarketplaceUserHandler,
}: Props): ReactElement => {
  const getUser = useCallback(
    (userId: string): MarketplaceUser | null => {
      if (users.length === 0) return null;
      const userToEdit = users.filter((user) => user._id === userId);

      if (userToEdit.length === 0) return null;
      return userToEdit[0];
    },
    [users],
  );

  const handleAddNew = () => {
    setModalErrorMsg('');
    setMarketplaceUser(null);
    setShowModal(true);
  };

  const editUser = useCallback(
    (userId: string) => {
      const mUser = getUser(userId);
      if (mUser) {
        setModalErrorMsg('');
        setMarketplaceUser(mUser);
        setShowModal(true);
      }
    },
    [getUser, setMarketplaceUser, setModalErrorMsg, setShowModal],
  );

  return (
    <div>
      <TableHeader>
        <h3 className="mb-0">Users</h3>
        <AddNewUser onClick={handleAddNew}>Add new</AddNewUser>
      </TableHeader>

      <UserDataTable
        userList={users}
        fetchListLoader={isLoading}
        isErrorRequest={!!fetchingError}
        handleEditUser={editUser}
        handleResendEmail={resendEmail}
        actionUsers={actionUsers}
      />

      {showModal && (
        <UserModal
          userFormProps={marketplaceUser ? toUserFormProps(marketplaceUser) : null}
          saveMarketplaceHendler={saveMarketplaceUserHandler}
          modalErrorMsg={modalErrorMsg}
          isModalLoading={isModalLoading}
          setShowModal={setShowModal}
        />
      )}
    </div>
  );
};

export default UserList;
